import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { Row } from '@simplywallst/ui-core';

export const HeroContentRow = styled(Row)`
  position: relative;
  color: ${({ theme }) => theme.color.spaceGray};
  padding-top: ${({ theme }) => theme.x6spacePx}px;
  ${media.lgUp`
    padding: ${({ theme }) => theme.x8spacePx}px 0 ${({ theme }) =>
      theme.x2spacePx}px 0;
  `};
  h1 {
    margin: -${({ theme }) => theme.x2spacePx}px 0;
    letter-spacing: -0.02em;
    ${({ theme }) => theme.typography.heroStrong};
    font-weight: 700;
    line-height: 110%;
    ${media.lgUp`
      ${({ theme }) => theme.typography.uberStrong};
      font-weight: 700;
      margin: 0;
      line-height: 62px;
    `};
  }
  p {
    ${({ theme }) => theme.typography.large};
    margin: ${({ theme }) => theme.x3spacePx}px 0;
    line-height: 27px;
    ${media.lgUp`
      ${({ theme }) => theme.typography.mega};
      line-height: 42px
    `};
  }
`;

export const HeroContent = styled('div')`
  margin: 0 ${({ theme }) => theme.x2spacePx}px;
`;
